import { Box, Typography } from "@mui/material"

const LandingProblemCard = ({ icon: Icon, title, description }) => (
    <Box className="landing-problem-card">
        <Box className="landing-problem-card__icon-wrap">
            <Icon fontSize="large" className="landing-problem-card__icon" />
        </Box>
        <Typography component="h3" className="landing-problem-card__title">
            {title}
        </Typography>
        <Typography component="p" className="landing-problem-card__description">
            {description}
        </Typography>
    </Box>
)

export default LandingProblemCard